var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84375 6.28125C6 6.125 6 5.90625 5.84375 5.75L1.28125 1.125C1.125 0.96875 0.875 0.96875 0.75 1.125L0.125 1.75C-0.03125 1.875 -0.03125 2.125 0.125 2.28125L3.8125 6L0.125 9.75C-0.03125 9.90625 -0.03125 10.125 0.125 10.2812L0.75 10.9062C0.875 11.0625 1.125 11.0625 1.28125 10.9062L5.84375 6.28125Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewArrow);
export default __webpack_public_path__ + "static/media/preview-arrow.7d9d6f3c.svg";
export { ForwardRef as ReactComponent };